import {
  APPLIED_FILTER_OPERATOR_GREATER_THAN,
  APPLIED_FILTER_OPERATOR_LESS_THAN,
  APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
} from '../../../../../../../../components/filter-editor/constants/applied-filter-operator';

export const OPERATOR_MAP: Record<string, string> = {
  greaterThan: APPLIED_FILTER_OPERATOR_GREATER_THAN,
  lessThan: APPLIED_FILTER_OPERATOR_LESS_THAN,
  equalTo: APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  greaterThanOrEqualTo: APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  lessThanOrEqualTo: APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
};

export const ORDER_TOTAL_FILTER_COLUMN = 'OrderTotal';
